<template>
  <router-link
    class="flex p-4 mb-1 rounded cursor-pointer text-white no-underline w-full hover:bg-gray-800"
    active-class="bg-gray-800"
    :to="route"
  >
    <div class="mr-4 w-4" v-if="icon">
      <font-awesome-icon :icon="icon"></font-awesome-icon>
    </div>
    <div>
      <slot></slot>
    </div>
  </router-link>
</template>


<script>
export default {
  props: ["icon", "to"],

  computed: {
    route() {
      if (this.to == undefined) {
        return { name: "" };
      } else if (this.to != null && typeof this.to === "object") {
        return this.to;
      } else {
        return { name: this.to };
      }
    }
  }
};
</script>
